import { Api } from 'lib/api.mjs';

/**
 * The what's-new banner.
 *
 * The read marker is server-side and per username, so signing out cannot lose
 * it and cannot make a dismissed entry reappear.
 */

export function getUpdates({ signal } = {}) {
  return Api.get('/updates', { signal });
}

/** @param {{ seq: number }} payload The highest entry the user has now seen. */
export function markUpdatesSeen({ seq }) {
  return Api.post('/updates/seen', { body: { seq } });
}
